"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const simplebar_react_1 = tslib_1.__importDefault(require("simplebar-react"));
require("simplebar-react/dist/simplebar.min.css");
const material_1 = require("@mui/material");
const styles_1 = require("./styles");
const SimpleBar = (0, material_1.styled)(simplebar_react_1.default)(({ theme }) => ({
    maxHeight: `calc(100vh - ${styles_1.DRAWER_FOOTER_HEIGHT}px)`,
    overflowX: "hidden",
    ".simplebar-scrollbar": {
        "&:before": {
            backgroundColor: theme.palette.text.secondary,
        },
    },
}));
exports.default = SimpleBar;
